<template>
  <div class="slideshow no-print">
    <el-carousel trigger="click" height="400px" arrow="always">
      <el-carousel-item v-for="(item, idx) in headerImages" :key="idx">
        <div class="slideshow-img"
          :style="{backgroundImage: 'url(' + item.pathLong + ')' }">
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="search-box">
      <div class="table">
        <div class="tr">
          <div class="td">
            <div class="search-input-box">
              <el-input accesskey="S" href="#search" title="search" class="search-input" @keydown.native="press_key" v-model="search_keyword" placeholder="請輸入搜尋條件"></el-input>
              <el-button class="btn-search" @click="search_clicked" circle>
                <i class="fas fa-search"></i>
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="related-keywords">
        <el-button 
          v-for="(term, idx) in query_term_list"
          :key="idx"
          type="text"
          @click="() => handle_query_term_clicked(term['term'])"
        >
          {{term['term']}}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import frontstageSearchMixin from '@/mixins/frontstageSearchMixin'
  import api from '@/api/frontstage'

  export default {
    name: "headerslide",
    mixins: [
      frontstageSearchMixin
    ],
    created () {
      this.udpate_query_term_list()
    },
    mounted() {
      this.importAll(require.context('../../assets/frontstage/images/home_banner/', true, /\.jpg$/i));
    },
    computed : {
      search_keyword: {
        set(keyword) {
          this.update_frontstage_search_keyword(keyword)
        },
        get (){
          return this.frontstage_search_keyword
        }
      }
    },
    data() {
      return {
        headerImages: [],
        query_term_list: [],
        query_term_total: 0
      }
    },
    methods: {
      importAll(r) {
        r.keys().forEach(key => (this.headerImages.push({ pathLong: r(key), pathShort: key })));
      },
      
      press_key(evt) {
        if (evt.keyCode === 13) {
          console.log('Enter is pressed, search keyword:', this.search_keyword)
          this.go_search_page()
        }
      },

      search_clicked() {
        console.log('Search has been clicked, search keyword:', this.search_keyword)
        this.go_search_page()
      },

      go_search_page() {
        this.$emit('do-search')
        this.$router.push({ path: `/collection` })
        this.udpate_query_term_list()
      },

      handle_query_term_clicked (term) {
        this.update_frontstage_search_keyword(term)
        this.go_search_page()
      },

      async udpate_query_term_list () {
        let res = await api.get_query_term_list()
        if (res.success) {
          console.log('[前臺] query term list: ', res)
          this.$set(this, 'query_term_list', res['payload']['payload']['search_result'])
          this.query_term_total = res['payload']['payload']['search_count']
        }
        else {
          this.$set(this, 'query_term_list', [])
          this.query_term_total = 0
          this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得列表', res.message)
        }
      }

    }
  }
</script>
<style lang="scss" scoped>
  /deep/ .el-carousel {
    overflow: hidden
  }
</style>

